<template>
	<el-container>
		<el-main style="width: 70%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">值班客服设置</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div>
				<div class="custom_div"><span>现在选择的客服：</span>
				<span style="color: red;" v-if="nightorName.length > 0">{{nightorName}}</span>
				</div>
				<el-select style="margin-right: 0.1875rem;" filterable v-model="selectCustmer.realName"
				placeholder="请选择同事" @change="optionChange" clearable>
					<el-option v-for="item in cusOptions"
					:key="item.id"
					:label="item.realName"
					:value="item.id">
					</el-option>
				</el-select>
			</div>

		</el-main>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				cusOptions:[],
				selectCustmer:{},
				nightorName:''
			}
		},

		created() {
			this.getSelectorRequest()
		},
		
		mounted() {
			this.getNightorsRequest()
		},

		methods: {
			async getSelectorRequest() {
				console.log("NightWork getSelectorRequest")
				
				var api = "/manager/onDutyCust/selectDutyCust"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
				})
				
				console.log('nightwork getSelectorRequest response = ', response.data)
				if (response.resultCode == 10000) {
					if (response.data != null) {
						this.selectCustmer = response.data
						this.nightorName = this.selectCustmer.realName
					}
					
					
				} else {
					this.$message.error(response.desc)
				}
			},
			
			async getNightorsRequest() {
				console.log("NightWork getNightorsRequest")

				var api = "/manager/sessStgyRegion/selectCustList"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
				})

				console.log('nightwork getNightorsRequest response = ', response.data)
				if (response.resultCode == 10000) {
					this.cusOptions = response.data
					
				} else {
					this.$message.error(response.desc)
				}

			},
			
			async optionChange(itemId) {
				console.log('NightWork optionChange item = ', itemId)
				if (itemId == '') {
					return
				}
				
				var api = "/manager/onDutyCust/add"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						csid: itemId,
					},
				})
				
				console.log('nightwork optionChange response = ', response.data)
				if (response.resultCode == 10000) {
					this.$message.success("设置值班客服成功")
					this.getSelectorRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

		}
	}
</script>

<style scoped="scoped">
	.custom_div {
		margin-bottom: 0.9375rem;
	}
	
	.custom_div > span  {
		font-size: 0.875rem;
		color: #444444;
	}
	
</style>
